<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { navigate } from 'svelte-routing';
    import { currentUser } from '../stores/currentUser';
	import BigSpinner from "../components/BigSpinner.svelte";

    export let title = '';
    
    const dispatch = createEventDispatcher();
	const handleKeydown = event => {
        if (event.keyCode == 13) {
            dispatch("enterPressed");
        }
    };
</script>

<svelte:head>
	<title>{title ? `${title} - ` : ''}Eastwood 45</title>
</svelte:head>

<svelte:window on:keydown={handleKeydown}/>

{#if $currentUser == null}
    <div class="modal">
        <BigSpinner/>
    </div>
{:else}
    {#if !$currentUser.isLoggedIn}
        <div class="modal">
            <div class="modal__box modal__box--sm">
                <div class="modal__header">
                    Authentication required
                </div>
                <div class="modal__body layout">
                    <div class="layout__column">
                        <div class="layout__item">
                            {#if $currentUser.userNotFound}
                                You need to be signed in to view this page.
                            {:else if !$currentUser.emailVerified}
                                Your email address is not verified.
                            {:else if !$currentUser.auth.member}
                                Please contact an admin to gain access to the website.
                            {:else}
                                An unknown error has occured.
                            {/if}
                        </div>
                        <div class="layout__row layout__row--space-between">
                            <div class="layout__item">
                                <div
                                    class="form__button form__button--subtle"
                                    on:click={() => navigate('/auth/sign-in')}>
                                    Go to sign in
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <div class="header">
            <div class="header__title" on:click={() => navigate('/')}>
                <div class="header__logo"></div>
                Eastwood 45
            </div>
            <div class="header__section">
                <ul class="header__menu">
                    <li class="header__item" on:click={() => navigate('/users')}>Users</li>
                    <li class="header__item header__item--parent">
                        {$currentUser.email}
                        <ul class="header__menu header__menu--child">
                            <li class="header__item" on:click={() => navigate('/change-password')}>Change password</li>
                            <li class="header__item" on:click={() => navigate('/auth/sign-in')}>Sign out</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <slot />
    {/if}
{/if}